import { ContentContainerType } from 'types/enums';
import { ContentContainer } from 'app/components/Core/ChakraContentContainer';
import { useState } from 'react';
import { useAppSelector } from 'app/store';
import { getRepresentatives } from 'app/store/Profile/selectors';
import { ChakraEmptyList } from 'app/components/Core';
import { RepresentativesListComponent } from './RepresentativesListComponent';
import { AddRepresentativeFab } from '../AddRepresentativeFab';
import { RepresentativeDialog } from '../RepresentativeDialog';

export const RepresentativesList = () => {
  const [addRepresentativeOpen, setAddRepresentativeOpen] = useState(false);
  const representativesList = useAppSelector(getRepresentatives);
  const loading = representativesList === undefined;

  return (
    <>
      <ContentContainer type={ContentContainerType.LIST} pt={4}>
        {!loading && representativesList.length === 0 ? (
          <ChakraEmptyList
            title="No Representatives"
            primaryText="Add your publishing and management information."
          />
        ) : (
          <RepresentativesListComponent
            loading={loading}
            representatives={representativesList || []}
          />
        )}
        <AddRepresentativeFab onClick={() => setAddRepresentativeOpen(true)} />
      </ContentContainer>
      <RepresentativeDialog
        open={addRepresentativeOpen}
        onClose={() => setAddRepresentativeOpen(false)}
      />
    </>
  );
};
